<template>
  <div>

    <!-- page banner -->
    <page-banner
      :title="paymentError ? $t('banner.error') : ( amend ? $t('banner.amending') : $t('banner.processing') )"
      :subTitle="$t('banner.sending_booking')"
      :promoBox="false"
      :breadcrumb="false"
    />
    
    <div class="main-area container style02">
      <div class="main-holder">
        <div class="row">
          <div class="col-12">
            <div class="confirmation-content text-center pt-5">
              <div class="payment-detail confirming">

                <!-- confirming status -->
                <h3 v-if="loading & !error" class="mb-3">{{ amend ? $t('confirmation.in_progress_amending') : $t('confirmation.in_progress') }}.</h3>
                <h3 v-if="error" class="text-danger">{{ $t(paymentError) }}.</h3>
                <loader v-if="!error" :loading="loading" color="#f6ab2f" size="20px"></loader>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { call, sync } from "vuex-pathify";
import { PageBanner } from "@/components";
import mixins from "@/mixins";
import Loader from "vue-spinner/src/PulseLoader.vue";

export default {
  name: 'confirming',
  mixins: [mixins.format, mixins.globals],
  components: { PageBanner, Loader },
  computed: {
    paymentError: sync("payment/error"),
    amend: sync("payment/amend"),
    error() {
      return this.paymentError.length > 0
    },
    confirmed: sync("payment/confirmed"),
  },
  data() {
    return {
      loading: true,
      calls: 0,
      maxCalls: 20
    }
  },
  mounted() {
    window.onbeforeunload = () => 'Your booking is being processed. It can take up to 3 minutes to confirm your payment. Please do not close or refresh this page.'
  },
  created() {
    this.paymentError = '';
    this.confirmed = false;
    this.amend = false;

    let session = this.$route.query["cko-session-id"]
    let id = this.$route.query["id"];

    let status = this.$route.query["status"];
    this.amend = (status === 'amend');

    if(!session && !id) {
      this.loading = false;
      this.paymentError = 'confirmation.error_confirming';
      return;
    }

    this.confirmBooking(session, id);
  },
  methods: {
    confirmBooking(session, id) {

      if(this.calls === this.maxCalls) this.paymentError = 'confirmation.error_confirming';
      if(this.error) return

      setTimeout(() => {
        
        this.confirm({ session, id, amend: this.amend }).then(() => {
          if(!this.confirmed) {
            this.calls++;

            setTimeout(() => {
              return this.confirmBooking(session, id);
            }, 15000)
            
          } else {
            return this.$router.replace({ path: 'confirmation', query: { id } }).catch(() => {});
          }
        })
      }, 5000)
    },
    confirm: call('payment/confirm')
  }
};
</script>